
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import { PopoutButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { JepGroupLayer, JepLayer } from '@jeppesen-foreflight/jmkw-types';
import { TwcPluginService } from '../plugins/twc.plugin.service';
import { TwcCheckboxesPopoutComponent } from './twc-checkboxes-popout/twc-checkboxes-popout.component';
import type { ResourceHandle } from "@arcgis/core/core/Handles";

@Component({
  selector: 'jmkw-twc-button',
  standalone: true,
  imports: [PopoutButtonComponent],
  templateUrl: './twc-button.component.html',
  styleUrls: ['./twc-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TwcButtonComponent implements OnInit {
  private readonly _twcPluginService = inject(TwcPluginService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);

  private _layerVisibilityIHandle?: ResourceHandle;

  readonly iconName = 'icon-weather';
  readonly tooltipText = 'Weather Channel Options';
  readonly componentRef = TwcCheckboxesPopoutComponent;
  readonly automationKey = 'weather-button';
  active = false;

  ngOnInit(): void {
    this._twcPluginService.weatherPlugin$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((plugin) => {
        this._destroyLayerVisibilityWatcher();
        if (plugin.children) {
          const layers = [...plugin.children.allLayers().values()];
          this.active = layers.some((layer) => layer.visible);
          this._cdr.markForCheck();
          this._setupLayerVisibilityWatcher(layers);
        }
      });
  }

  private _destroyLayerVisibilityWatcher(): void {
    this._layerVisibilityIHandle?.remove();
  }

  private _setupLayerVisibilityWatcher(
    layers: Array<JepLayer | JepGroupLayer>
  ): void {
    this._layerVisibilityIHandle = reactiveUtils.watch(
      () => layers.map((layer) => layer.visible),
      (visibleStates) => {
        this.active = visibleStates.some((isVisible) => isVisible);
      }
    );
  }
}
